module.exports = __webpack_public_path__ + "img/gs-img-3_en.6a212969.png";